import { JOIN_LESSON_TOGGLE } from '../Type';

export const toggleJoinLesson = (isOpen, info = {}) => {
  return {
    type: JOIN_LESSON_TOGGLE,
    data: { isOpen, info }
  }
}